import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const RoadBlockFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M14 3.8L15.36 8.02H8.64L10 3.8H14ZM6.9 13.44L8.1 9.74H15.9L17.1 13.44H6.9ZM5.1 19L6.34 15.16H17.66L18.9 19H5.1Z" />
    </SvgIcon>
  );
});
